// Port of api/fuel/app/classes/insights/hindex/type.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'type',
    priority: 1,
    default_: false,
    requires: ['init'],
    insight: false,
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var typeFilter = (filter && filter.type) ? filter.type : 'category'

        var table = (typeFilter === 'category') ? 'category' : 'mechanic'

        var typeNameRow = Util.query(
            'SELECT ' + table + '_name AS name FROM ' + table +
            ' WHERE ' + table + '_id = ' + vars.id
        )
        var typeName = typeNameRow.length ? typeNameRow[0].name : ''

        var gamesIndex = this._data.current.get_index_level()

        var games = []

        var ratings = Util.query(
            'SELECT l.game_id as g, AVG(r.rating_value) AS r, COUNT(DISTINCT r.rating_id) AS c' +
            ' FROM game_' + table + ' l, game g' +
            ' LEFT JOIN rating r ON r.game_id = g.game_id' +
            ' AND r.user_id IN (' + Util.in(userIndex) + ')' +
            ' WHERE l.game_id IN (' + Util.in(gamesIndex) + ')' +
            ' AND l.' + table + '_id = ' + vars.id +
            ' AND g.game_id = l.game_id' +
            ' AND g.game_type = 1' +
            this._data.filter +
            ' GROUP BY l.' + table + '_id, l.game_id' +
            ' ORDER BY AVG(r.rating_value) DESC, g.game_name ASC' +
            ' LIMIT 0, 250'
        )

        for (var i = 0; i < ratings.length; i++) {
            var game = ratings[i]
            this._references.games.push(parseInt(game.g, 10))

            games.push({
                id: parseInt(game.g, 10),
                count: parseInt(game.c, 10),
                rating: game.r ? parseFloat(game.r) : '-'
            })
        }

        return {
            type: typeName,
            games: games
        }

    }
})
